export default __webpack_public_path__ + "static/media/main_section7.e9391c3f.jpg";